<template>
	<div>
		<v-chip color="secondary" text-color="primary" class="mb-6">
			Betaling fullført
			<v-icon right>check_circle</v-icon>
		</v-chip>
		<section v-if="giftcard.deliveryMethod == deliveryMethods.MAIL.id">
			<h2>Fixit.no-gavekort på vei!</h2>
			<div>
				Gavekortet blir levert til oppgitt leveringsadresse innen 4-5 virkedager.
				<br />
				<br />
			</div>

			<v-btn depressed color="primary" href="/kjop-gavekort">Kjøp flere gavekort</v-btn>
		</section>
		<section v-if="giftcard.deliveryMethod == deliveryMethods.PDF.id">
			<h2>Fixit.no-gavekort er klart til å skrives ut!</h2>
			<div>
				Hvis du ønsker å gjøre dette ved en senere anledning, kan du alltid finne det igjen på din ordrehistorikk under min side.
				<br />
				<br />
				En kvittering for kjøpet er sendt til {{ email }}. Kjøpsdetaljer kan du også finne på
				<a href="/minside/ordrehistorikk">fixit.no/minside/ordrehistorikk</a>
				<br />
			</div>
			<br />
			<div>
				<v-btn depressed color="primary" @click="openPrintGiftCardDialog">Skriv ut gavekort</v-btn>
				<v-btn depressed color="primary" text class="ml-3" href="/kjop-gavekort">Kjøp gavekort</v-btn>
			</div>
			<br />
		</section>
		<section v-if="giftcard.deliveryMethod == deliveryMethods.SMS.id">
			<h2 v-if="isDateAfter(giftcard.deliverySMSTime)">Fixit.no-gavekort er klar for utsending!</h2>
			<h2 v-else>Fixit.no-gavekort er nå sendt!</h2>
			<div>
				Gavekortet <template v-if="isDateAfter(giftcard.deliverySMSTime)">blir sendt til</template><template v-else>har nå blitt sendt til</template> {{ giftcard.deliveryPhoneNumber
				}}<template v-if="isDateAfter(giftcard.deliverySMSTime)">, {{ formatDate(giftcard.deliverySMSTime) }}</template>
				<br />
				En kvittering for kjøpet er sendt til {{ email }}. Kjøpsdetaljer kan du også finne på
				<a href="/minside/ordrehistorikk">fixit.no/minside/ordrehistorikk</a>
				<br />
				<br />
			</div>

			<v-btn color="primary" depressed href="/kjop-gavekort">Kjøp flere gavekort</v-btn>
		</section>
		<PrintGiftCardDialog v-model="show" v-bind:giftcardNumber="selectedGiftCardId"></PrintGiftCardDialog>
	</div>
</template>

<script>
// import { GiftCardPurchaseDetails } from '@/services/models';
import { DeliveryMethodEnum } from '@/services/enums/deliveryMethods';
import PrintGiftCardDialog from '@/views/giftcard/components/print-giftcard/PrintGiftcardDialog';
import moment from 'moment';
export default {
	name: 'buy-giftcard-completed',
	components: { PrintGiftCardDialog },
	props: {
		giftcard: null,
		requiresInternalHandling: Boolean,
		email: null,
		value: null // Current step
	},
	data() {
		return {
			deliveryMethods: DeliveryMethodEnum,
			show: false,
			selectedGiftCardId: ''
		};
	},
	computed: {
		currentStep: {
			get() {
				return this.value || -1;
			},

			set(value) {
				this.$emit('input', value);
			}
		}
	},
	mounted() {},
	methods: {
		openPrintGiftCardDialog() {
			const id = this.giftcard.externalGiftcardId;
			this.show = true;
			this.selectedGiftCardId = id + '';
		},
		formatDate(date) {
			return moment(date).format('DD. MMMM YYYY') + ' kl. ' + moment(date).format('HH:mm');
		},
		isDateAfter(date) {
			return !moment(date).isBefore(new Date());
		}
	}
};
</script>
